import React, { useState, useEffect } from "react";
import { adminCreateCategory, adminUpdateCategory } from "../api/admin";
import "./CategoryForm.css";
import ImageUpload from "./ImageUpload";
import { toast } from "react-toastify";

const CategoryForm = ({ category, onSuccess, onCancel }) => {
  const [name, setName] = useState("");
  const [images, setImages] = useState([]); // Array of { url, file }
  const [status, setStatus] = useState(true);

  useEffect(() => {
    if (category) {
      setName(category.category_name ?? "");
      const catImg = category.category_image;
      const imageUrl = (typeof catImg === 'object' && catImg !== null) ? catImg.url : catImg;
      setImages(imageUrl ? [{ url: imageUrl, file: null }] : []);
      setStatus(category.status ?? true);
    } else {
      setName("");
      setImages([]);
      setStatus(true);
    }
  }, [category]);

  const handleAddImages = (files) => {
    // Category typically has only one image
    const file = files[0];
    if (file) {
      setImages([{
        url: URL.createObjectURL(file),
        file: file
      }]);
    }
  };

  const removeImage = () => {
    setImages(prev => {
      if (prev.length > 0 && prev[0].file) {
        URL.revokeObjectURL(prev[0].url);
      }
      return [];
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) return;

    const formData = new FormData();
    formData.append("category_name", name);
    formData.append("status", status ? "true" : "false");

    // Handle image
    if (images.length > 0) {
      if (images[0].file) {
        formData.append("category_image", images[0].file);
      }
      // Do not append string URL for existing images to avoid Pydantic value_error
    } else {
      formData.append("category_image", "");
    }

    try {
      if (category) {
        const categoryId = category.category_id || category._id || category.id;
        await adminUpdateCategory(categoryId, formData);
        toast.success("Category updated successfully! ✨");
      } else {
        await adminCreateCategory(formData);
        toast.success("Category created successfully! 🎉");
      }
      onSuccess();
      setName("");
      setImages([]);
      setStatus(true);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to save category. ❌");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="form-body">
        <div className="form-grid">
          <div className="form-group">
            <label>Category Name <span className="required-star">*</span></label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter category name"
              required
            />
          </div>

          <div className="form-group">
            <label>Category Image</label>
            <ImageUpload
              images={images}
              onAdd={handleAddImages}
              onRemove={removeImage}
              multiple={false}
              id="category-image-upload"
            />
          </div>
        </div>

        <div className="offer-options">
          <label className="checkbox-card">
            <input
              type="checkbox"
              checked={status}
              onChange={(e) => setStatus(e.target.checked)}
            />
            <span>Active Status</span>
          </label>
        </div>
        <div className="form-footer">
          <button type="submit" className="btn-submit">
            {category ? "Update Category" : "Save Category"}
          </button>
          <button type="button" className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
};

export default CategoryForm;
